(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ReactRouterInnerHTMLLinks"] = factory();
	else
		root["ReactRouterInnerHTMLLinks"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Links = __webpack_require__(1);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Links).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reactRouterScrollPosition = __webpack_require__(2);

var _animateScrollTo = __webpack_require__(3);

var _animateScrollTo2 = _interopRequireDefault(_animateScrollTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Handle hash locations
 */
var Links = function () {
  /**
   * Construct new object from form element
   */
  function Links(elem, history) {
    var _this = this;

    _classCallCheck(this, Links);

    // This binding is necessary to make `this` work in the callback
    this.boundNavigate = function (e) {
      return _this.navigate(e);
    };
    this.history = history;

    /**
     * Add click listener to all links
     */
    var excludedLinks = Array.from(elem.querySelectorAll('div[data-nolinks] a'));
    var allLinks = Array.from(elem.getElementsByTagName('a'));
    this.links = allLinks.filter(function (htmlElement) {
      var includes = excludedLinks.includes(htmlElement);
      return !includes;
    });
    this.length = this.links.length;
    this.addListeners();
  }

  /**
   * Loop over all links to bind scroll function
   *
   * @return void
   */


  Links.prototype.addListeners = function addListeners() {
    var i = 0;

    for (i; i < this.length; i += 1) {
      var link = this.links[i];

      if (link.hasAttribute('href')) {
        var href = link.getAttribute('href');

        if (href.length > 0) {
          var isHash = href[0] === '#';

          if (isHash) {
            if (href.length > 1) {
              link.addEventListener('click', Links.toHash, false);
            } else {
              link.addEventListener('click', Links.preventDefault, false);
            }
          } else if (!link.hasAttribute('target')) {
            link.addEventListener('click', this.boundNavigate, false);
          }
        }
      }
    }
  };

  /**
   * Loop over all links to remove scroll function
   *
   * @return void
   */


  Links.prototype.removeListeners = function removeListeners() {
    var i = 0;

    for (i; i < this.length; i += 1) {
      var link = this.links[i];

      if (link.hasAttribute('href')) {
        var href = link.getAttribute('href');

        if (href.length > 0) {
          var isHash = href[0] === '#';

          if (isHash) {
            if (href.length > 1) {
              link.removeEventListener('click', Links.toHash, false);
            } else {
              link.removeEventListener('click', Links.preventDefault, false);
            }
          } else if (!link.hasAttribute('target')) {
            link.removeEventListener('click', this.boundNavigate, false);
          }
        }
      }
    }
  };

  /**
   * Navigate to new page
   *
   * @param e object Mouse event that's triggered after link click
   *
   * @return void
   */


  Links.prototype.navigate = function navigate(e) {
    e.preventDefault();

    // Get href from elem
    var href = e.currentTarget.getAttribute('href');

    // New tab check
    var hasProtocol = href.includes('http://') || href.includes('https://');
    var isOrigin = href.includes(window.location.origin);

    // Current window check
    var isMail = href.includes('mailto:');
    var isTel = href.includes('tel:');

    // Check what to do with link
    if (hasProtocol && !isOrigin) {
      window.open(href);
    } else if (isMail || isTel) {
      window.location.href = href;
    } else {
      this.history.push(href.replace(window.location.origin, ''));
    }
  };

  /**
   * Prevent normal behaviour
   *
   * @param e object Mouse event that's triggered after link click
   *
   * @return void
   */


  Links.preventDefault = function preventDefault(e) {
    e.preventDefault();
  };

  /**
   * Scroll to hash location from a link
   *
   * @param e object Mouse event that's triggered after link click
   *
   * @return void
   */


  Links.toHash = function toHash(e) {
    e.preventDefault();

    var target = document.querySelector(e.currentTarget.getAttribute('href'));
    var top = (0, _reactRouterScrollPosition.getElemTop)(target);

    (0, _animateScrollTo2.default)(top, 500);
  };

  return Links;
}();

exports.default = Links;
module.exports = exports['default'];

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ReactRouterScrollPosition"] = factory();
	else
		root["ReactRouterScrollPosition"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _helpers = __webpack_require__(1);

Object.defineProperty(exports, 'setScrollPosition', {
  enumerable: true,
  get: function get() {
    return _helpers.setScrollPosition;
  }
});
Object.defineProperty(exports, 'storeScrollPosition', {
  enumerable: true,
  get: function get() {
    return _helpers.storeScrollPosition;
  }
});
Object.defineProperty(exports, 'getElemTop', {
  enumerable: true,
  get: function get() {
    return _helpers.getElemTop;
  }
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Scroll position of particular element
 *
 * @param elem object Element to scroll to
 *
 * @return int
 */
var getElemTop = exports.getElemTop = function getElemTop(elem) {
  var top = 0;

  // Check if element exists
  if (elem.nodeType === 1) {
    // Calculate top
    var box = elem.getBoundingClientRect();
    var _document = document,
        body = _document.body;

    // Get top

    var scrollTop = window.pageYOffset || document.scrollTop || body.scrollTop;
    var clientTop = document.clientTop || body.clientTop || 0;
    top = Math.round(box.top + scrollTop - clientTop);

    // Loop over fixed elements to remove height from scroll position
    var fixedElems = document.querySelectorAll('[data-fixed]');

    if (fixedElems) {
      var fixedElemsLength = fixedElems.length;

      for (var i = 0; i < fixedElemsLength; i += 1) {
        var fixedElem = fixedElems[i];

        if (fixedElem.nodeType === 1) {
          top -= fixedElem.offsetHeight;
        }
      }
    }
  }

  return top;
};

/**
 * Run to set scroll to correct position
 *
 * @param history object History object from react router
 */
var setScrollPosition = exports.setScrollPosition = function setScrollPosition(history) {
  var hash = window.location.hash;


  var scroll = 0;

  // Check if it's pop action (back, forward, reload)
  if (history && history.action === 'POP') {
    // Get location key
    var key = history.location.key;

    // Set scroll position to location if there is a scroll position found in session

    if (sessionStorage.getItem(key)) {
      scroll = parseFloat(sessionStorage.getItem(key));
    }
  } else if (hash) {
    // Check if element with has location exists
    var hashEl = document.querySelector(hash);

    if (hashEl) {
      scroll = getElemTop(hashEl);
    }
  }

  // Set scroll position correctly
  window.scrollTo(0, scroll);
};

/**
 * Store scroll position if location is switched
 *
 * @param oldLoc object The old location prop
 * @param newLoc object The new location prop
 */
var storeScrollPosition = exports.storeScrollPosition = function storeScrollPosition(oldLoc, newLoc) {
  // Get old and new location key
  var oldKey = oldLoc.key;
  var newKey = newLoc.key;

  // Set storage of current scroll position on page change
  if (oldKey !== newKey) {
    var scrollTop = window.pageYOffset || document.scrollTop || document.body.scrollTop;

    sessionStorage.setItem(oldKey, scrollTop);
  }
};

/***/ })
/******/ ]);
});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["AnimateScrollTo"] = factory();
	else
		root["AnimateScrollTo"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _helpers = __webpack_require__(1);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_helpers).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Scroll = __webpack_require__(2);

var _Scroll2 = _interopRequireDefault(_Scroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var animateScrollTo = function animateScrollTo(to, duration) {
  var scroll = new _Scroll2.default(to, duration);

  scroll.animateScroll();
};

exports.default = animateScrollTo;
module.exports = exports['default'];

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Scroll = function () {
  /**
   * Scroll to a particular location
   *
   * @param to       int Pixels to scroll to
   * @param duration int How long scroll must take in ms
   */
  function Scroll(to, duration) {
    _classCallCheck(this, Scroll);

    this.elapsed = 0;
    this.start = window.pageYOffset;
    this.change = to - this.start;
    this.duration = duration;
    this.increment = 20;
  }

  /**
   * Animate scrolling
   */


  Scroll.prototype.animateScroll = function animateScroll() {
    var _this = this;

    this.elapsed += this.increment;

    // Get new position
    var position = this.easeInOut();

    // Scroll to new position
    window.scrollTo(0, position);

    // Rerun function if position is not yet correct
    if (this.elapsed < this.duration) {
      setTimeout(function () {
        return _this.animateScroll();
      }, this.increment);
    }
  };

  /**
   * easeInOut animation for scrolling
   */


  Scroll.prototype.easeInOut = function easeInOut() {
    var elapsed = this.elapsed;
    var start = this.start,
        change = this.change,
        duration = this.duration;


    elapsed /= duration / 2;

    if (elapsed < 1) {
      return change / 2 * elapsed * elapsed + start;
    }

    elapsed -= 1;

    return -change / 2 * (elapsed * (elapsed - 2) - 1) + start;
  };

  return Scroll;
}();

exports.default = Scroll;
module.exports = exports["default"];

/***/ })
/******/ ]);
});

/***/ })
/******/ ]);
});